import {Directive, ElementRef, Input, EventEmitter, HostListener} from '@angular/core';

@Directive({
  selector: '[cui-swipeable-action]'
})
export class CuiSwipeableActionDirective {
  @Input('cui-swipeable-action')
  position: 'left' | 'right';

  execute$ = new EventEmitter<void>();

  constructor(private elementRef: ElementRef) { }

  @HostListener('click')
  clicked() {
    this.execute$.emit();
  }

  execute() {
    this.elementRef.nativeElement.click();
  }
}



// WEBPACK FOOTER //
// ./node_modules/@cicero/webui/lib/core/swipeable/swipeable-action.directive.ts